import 'isomorphic-fetch'
import moment from 'moment'
import uuid from 'uuid/v4'

export const isLogin = (accessToken, accessTokenExpiresAt) => {
  const unixtime = parseInt(moment.utc().format('X'), 10)
  return accessToken && unixtime <= accessTokenExpiresAt
}

export const defaultOptions = (options, config) => {
  const { accessToken, historyId, userAgent, referrer } = options

  let headers = {
    'Spacemarket-Version': config.SPM_GRAPHQL_API_VERSION,
    'x-api-key': config.SPM_GRAPHQL_API_KEY,
    'Accept-Language': 'ja-jp',
  }

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  let sendHistoryId = historyId
  if (!sendHistoryId) {
    sendHistoryId = uuid()
  }
  headers = Object.assign(headers, {
    'Spacemarket-Forwarded-History-Id': sendHistoryId,
    'Spacemarket-Forwarded-Referer': referrer || '',
    'Spacemarket-Forwarded-User-Agent': userAgent,
  })

  return {
    mode: 'cors',
    headers,
  }
}
